module.exports = __webpack_public_path__ + "static/media/back-btn.006434ff.svg";